import {Aggregation, AggregationOption, SortFields} from '@/__generated__/__types__';
import {PageType} from '@/_application/core/types';

export interface DisplayToolbarProps {
    aggregations: Aggregation[];
    sortFields: SortFields;
    currentPage?: PageType;
}
export interface DisplayOptions {
    title: string;
    image: string;
    type: DisplayOptionsType;
}

export enum DisplayOptionsType {
    SORTING = 'SORTING',
    FILTERING = 'FILTERING',
    NONE = 'NONE',
}

export interface FilterByPriceInput {
    min: number;
    max: number;
}

export interface BrandByLetterType {
    id: string;
    data: AggregationOption[];
}
